export default class ValueRange {
	constructor(value, options) {
		this.options = options;
		this.matcher = new RegExp('^([\[\(])(.*),(.*)([\)\\]])$');

		this.value = ko_helper.safe_observable(value, '[,)');
		this.last_value = null;

		this.from_inclusive = ko.observable(true);
		this.to_inclusive = ko.observable(false);

		this.from_value = ko.observable(null);
		this.to_value = ko.observable(null);

		this.from_unbounded = ko.observable(false);
		this.to_unbounded = ko.observable(false);

		this.value.subscribe((value) => this.parse_value(value));
		this.from_inclusive.subscribe(() => this.set_value());
		this.to_inclusive.subscribe(() => this.set_value());
		this.from_value.subscribe(() => this.set_value());
		this.to_value.subscribe(() => this.set_value());
		this.from_unbounded.subscribe(() => this.set_value());
		this.to_unbounded.subscribe(() => this.set_value());

		this.parse_value(this.value());
	}

	parse_value(value) {
		if (value == this.last_value) return;
		this.last_value = value;

		const matches = this.matcher.exec(value);
		if (matches?.length === 5) {
			matches[1] == '[' ? this.from_inclusive(true) : this.from_inclusive(false);
			matches[4] == ']' ? this.to_inclusive(true) : this.to_inclusive(false);

			let from = matches[2];
			let to = matches[3];

			if (this.options?.deserialize_function) {
				from = this.options.deserialize_function(from);
				to = this.options.deserialize_function(to);
			}

			this.from_value(from);
			this.to_value(to);

			if (!(from && from.toString().trim().length))
				this.from_unbounded(true);

			if (!(to && to.toString().trim().length))
				this.to_unbounded(true);
		}
	}

	toggle_from_inclusive() {
		if (this.from_unbounded() === true) {
			this.from_unbounded(false);
		}
		else {
			if (this.from_inclusive() === true) {
				this.from_inclusive(false);
			}
			else {
				this.from_inclusive(true);
				this.from_unbounded(true);
			}
		}
	}

	toggle_to_inclusive() {
		if (this.to_unbounded() === true) {
			this.to_unbounded(false);
		}
		else {
			if (this.to_inclusive() === true) {
				this.to_inclusive(false);
			}
			else {
				this.to_inclusive(true);
				this.to_unbounded(true);
			}
		}
	}

	set_value() {
		let from = this.from_value()?.toString() ?? '';
		let to = this.to_value()?.toString() ?? '';

		if (this.options?.serialize_function) {
			from = this.options.serialize_function(from);
			to = this.options.serialize_function(to);
		}

		let parts = [];

		parts.push(this.from_inclusive() ? '[' : '(');
		if (this.from_unbounded() === false)
			parts.push(from ? from : '');
		parts.push(',');
		if (this.to_unbounded() === false)
			parts.push(to ? to : '');
		parts.push(this.to_inclusive() ? ']' : ')');

		let value = parts.join('');
		this.last_value = value;
		this.value(value);
	}

	contains(value) {
		let from = this.from_value();
		let to = this.to_value();

		if (from !== undefined && from !== null && from !== '') {
			if (this.from_inclusive()) {
				if (value < from) return false;
			}
			else {
				if (value <= from) return false;
			}
		}

		if (to !== undefined && to !== null && to !== '') {
			if (this.to_inclusive()) {
				if (value > to) return false;
			}
			else {
				if (value >= to) return false;
			}
		}

		return true;
	}
}
